// The External Feed token travels in the URL hash fragment (e.g.
// `/external-feeds#<token>` or `/external-feeds/embed#<token>`) so it is never
// sent to the server. Datadog RUM still captures the full browser URL —
// including the fragment — on view events, so the token is scrubbed there
// before ingestion.
const EXTERNAL_FEED_HASH_TOKEN = /(\/external-feeds(?:\/embed)?#)[^\s#]+/g;

const REDACTED = "[REDACTED]";

/**
 * Replaces the External Feed bearer token carried in a URL hash fragment so it
 * is safe to emit in browser telemetry.
 */
export function redactExternalFeedTokenFromUrl(url: string): string;
export function redactExternalFeedTokenFromUrl(url: undefined): undefined;
export function redactExternalFeedTokenFromUrl(
  url: string | undefined
): string | undefined {
  if (!url) {
    return url;
  }

  return url.replace(EXTERNAL_FEED_HASH_TOKEN, `$1${REDACTED}`);
}
